import { Component, ViewEncapsulation } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { NgOtpInputModule, NgOtpInputConfig } from "ng-otp-input";

@Component({
  selector: "kzn-otp-input",
  standalone: true,
  imports: [NgOtpInputModule],
  templateUrl: "./otp-input.component.html",
  styleUrl: "./otp-input.component.scss",
  encapsulation: ViewEncapsulation.None,
})
export class OtpInputComponent {
  public config: NgOtpInputConfig = {
    length: 6,
    allowNumbersOnly: true,
    containerClass: "otp-input-container",
    inputClass: "",
    disableAutoFocus: true,
  };
  public otpFormCtrl: FormControl = new FormControl(null, [
    Validators.required,
    Validators.minLength(6),
  ]);

  constructor() {
    this.otpFormCtrl.statusChanges.subscribe((status) => {
      this.updateInputClass(status === "INVALID" ? "invalid" : "");
    });
  }

  public updateInputClass(className: string = ""): void {
    this.config = { ...this.config, inputClass: className };
  }

  public onOtpChange(value: string): void {
    this.otpFormCtrl.setValue(value ?? "");
    this.otpFormCtrl.markAsDirty();
  }

  public onFocusOut(): void {
    this.otpFormCtrl.markAsTouched();
    this.updateInputClass(this.otpFormCtrl.invalid ? "invalid" : "");
  }

  public isOtpInputValid(): boolean {
    return this.otpFormCtrl.valid;
  }

  public getOtpValue(): string {
    return this.otpFormCtrl.value;
  }
}
